export const CommonEnvironment = {
    endPoints: {
        processorDrivers: 'consents/v1/processorDrivers'
    }
};
